import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../store';

export function ForgotPasswordForm() {
  const { t } = useTranslation();
  const email = useAuth(s => s.email);
  const authLoading = useAuth(s => s.authLoading);
  const authError = useAuth(s => s.authError);
  const forgotSent = useAuth(s => s.forgotSent);
  const setEmail = useAuth(s => s.setEmail);
  const setAuthView = useAuth(s => s.setAuthView);
  const resetAuthForm = useAuth(s => s.resetAuthForm);
  const handleForgotPassword = useAuth(s => s.handleForgotPassword);

  const onSubmit = (e: React.FormEvent) => { e.preventDefault(); handleForgotPassword(); };

  return (
    <form onSubmit={onSubmit} className="space-y-3">
      <p className="text-sm font-medium text-gray-700">{t('storeSettings.forgotPasswordTitle')}</p>
      <p className="text-xs text-gray-500">{t('storeSettings.forgotPasswordHint')}</p>

      {forgotSent ? (
        <>
          <p className="text-sm text-green-600">{t('storeSettings.resetLinkSent')}</p>
          <button
            type="button"
            onClick={() => { setAuthView('reset'); resetAuthForm(); }}
            className="w-full rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
          >
            {t('storeSettings.resetPasswordTitle')} →
          </button>
        </>
      ) : (
        <>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder={t('storeSettings.email')}
            required
            autoComplete="email"
            className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {authError && <p className="text-sm text-red-600">{authError}</p>}
          <div className="flex gap-2">
            <button
              type="submit"
              disabled={authLoading || !email.trim()}
              className="flex-1 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
            >
              {authLoading ? t('storeSettings.sendingResetLink') : t('storeSettings.sendResetLink')}
            </button>
            <button
              type="button"
              onClick={() => { setAuthView('login'); resetAuthForm(); }}
              className="rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-600 hover:bg-gray-50"
            >
              {t('common.cancel')}
            </button>
          </div>
        </>
      )}
      <div className="text-xs text-center">
        <button
          type="button"
          onClick={() => { setAuthView('login'); resetAuthForm(); }}
          className="text-blue-600 hover:underline"
        >
          {t('storeSettings.backToLogin')}
        </button>
      </div>
    </form>
  );
}
